import React from "react";
import { NoSettings } from "./sectionFormKit";

// Customer: components/sections/ProductDetail/ProductDetail.js
const ProductDetail = () => (
  <NoSettings text="Product details for /products/:slug, loaded from the product catalog. No settings." />
);

export default ProductDetail;
